import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title =
      "Blog – Rechtliche Beiträge zu Internetrecht & Bewertungen | RA Sindros";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "Fachbeiträge zu Internetrecht, Bewertungslöschung und Persönlichkeitsrecht von Rechtsanwalt Sindros."
      );

    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${API}/blog`);
        setPosts(response.data);
      } catch (err) {
        console.error("Failed to fetch blog posts:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div>
      {/* Hero */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <h1
            className="text-4xl lg:text-5xl font-bold mb-6"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            Blog
          </h1>
          <p className="text-lg max-w-2xl" style={{ color: "#555555" }}>
            Rechtliche Beiträge zu Internetrecht, Bewertungsrecht und digitaler
            Reputation.
          </p>
        </div>
      </section>

      {/* Articles */}
      <section style={{ backgroundColor: "#F5F5F5" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {loading ? (
              <p className="text-sm col-span-3" style={{ color: "#777" }}>Artikel werden geladen...</p>
            ) : posts.length === 0 ? (
              <p className="text-sm col-span-3" style={{ color: "#777" }}>Noch keine Artikel vorhanden.</p>
            ) : (
              posts.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="bg-white rounded-lg p-8 shadow-sm block group"
                style={{ transition: "box-shadow 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 1px 2px 0 rgba(0,0,0,0.05)")
                }
              >
                <time
                  className="text-xs font-medium tracking-wider uppercase"
                  style={{ color: "#2E75B6" }}
                >
                  {formatDate(post.date)}
                </time>
                <h2
                  className="text-lg font-semibold mt-4 mb-4 leading-snug"
                  style={{ color: "#1B3A5C" }}
                >
                  {post.title}
                </h2>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "#555555" }}
                >
                  {post.preview}
                </p>
                <span
                  className="inline-block mt-6 text-sm font-medium"
                  style={{ color: "#2E75B6" }}
                >
                  Weiterlesen
                </span>
              </Link>
            ))
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
